import React from 'react'
import { FieldRenderProps } from 'react-final-form'

import SelectInput from '../input/SelectInput'
import SelectWithTranslate from '../input/SelectInput/SelectWithTranslate'
import withFormBlock from './FormBlock/withFormBlock'

interface FormSelectProps extends FieldRenderProps<any, any> {
   submitting?: boolean
   translate?: boolean
   disabled?: boolean
   options?: any[]
}

const FormSelect = ({ input, translate, ...rest }: FormSelectProps) => {
   return translate ? <SelectWithTranslate {...input} {...rest} /> : <SelectInput {...input} {...rest} />
}

export default withFormBlock<FormSelectProps>(FormSelect)
